import { compile } from './view/Compiler';
import { context } from './view/Template';

var _source = {};

export function source( obj:{} ) {
	_source = obj;
};

/**
 * translates the given key.
 */
export function translate( key:string, opts:{ data?:any, condition?:number } = {} ):any {
	if( key == undefined ) return '';

	var def = lookup( key );
	if( opts.condition != undefined ) def = matchCondition( def, opts.condition );
	if( opts.data ) def = compile( def ).call( context, opts.data );

	return def;
}

function matchCondition( value:string, num:number ) {

	var parts = value.split( '|' );

	// check conditions
	var found = parseConditions( parts, num )
	if( found ) return found.trim();

	if( parts.length == 1 ) return clearConditions( parts[0] );

	// check simple | split
	return clearConditions( parts[ ( num == 1 ) ? 0 : 1 ] );
}


function parseConditions( parts, number:number ):string {
	// loop over parts
	for( var i = 0; i < parts.length; i++ ) {
		var regex = /^[\{\[]([^\[\]\{\}]*)[\}\]](.*)/;
		var match = regex.exec( parts[i] );

		// no proper condition
		if( match == null || match.length != 3 ) continue;

		var value = match[2];
		var condition = match[1];
		var num = number;

		// range condition
		if( condition.indexOf( ',' ) > -1 ) {

			var [ from , to ] = condition.split( ',' );

			if ( to == '*' && num >= parseInt( from ) ) {
				return value;
			} else if ( from == '*' && num <= parseInt( to ) ) {
				return value;
			} else if ( num >= parseInt( from ) && num <= parseInt( to ) ) {
				return value;
			}

		// exact condition
		} else if( parseInt( condition ) == num ) {
			return value;
		}
	}
}

function clearConditions( s:string ):string {
	return s.replace( /^[\{\[]([^\[\]\{\}]*)[\}\]]/, '' ).trim();
}

function lookup( key:string ) {

	// translate `x.y` to `data["x"]["y"]` which is safe even when special chars are present:
	let template = '[[ data' + key.split( '.' ).map( k => '["' + k + '"]' ).join( '' ) + ' ]]';

	// lookup property / string in source
	let result = compile( template ).call( context, _source );

	// return result only if its a valid string otherwise return key
	return ( typeof result == 'string' ) ? result : key;
}
